import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "ap_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    const addItem = (product, qty = 1) => {
        setItems((prev) => {
            const idx = prev.findIndex((i) => i.id === product.id);
            if (idx >= 0) {
                const next = [...prev];
                next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
                return next;
            }
            return [...prev, {
                id: product.id,
                slug: product.slug,
                name: product.name,
                strength: product.strength,
                price: product.price,
                image: product.image,
                quantity: qty,
            }];
        });
    };

    const updateQty = (id, qty) => {
        setItems((prev) => prev.map((i) => (i.id === id ? { ...i, quantity: Math.max(1, qty) } : i)));
    };

    const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);

    const totalQty = items.reduce((s, i) => s + i.quantity, 0);

    // Display preview total (server is authoritative on quote)
    const subtotal = items.reduce((s, i) => {
        const qty = i.quantity;
        const disc = qty >= 3 ? 0.053 : qty === 2 ? 0.036 : 0;
        return s + i.price * qty * (1 - disc);
    }, 0);

    return (
        <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clear, totalQty, subtotal }}>
            {children}
        </CartCtx.Provider>
    );
}

export const useCart = () => useContext(CartCtx);
